// src/components/Charts/ResourceUtilizationChart.js

import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import AssetsDropdown from '../../tabs/Dropdown/Assetsdropdown';
import api from '../../../../api';

const ResourceUtilizationChart = () => {
  const [assetId, setAssetId] = useState(1);
  const [chartData, setChartData] = useState({
    series: [0, 0],
    assetName: '',
    loading: true,
    error: null,
    noData: false
  });

  useEffect(() => {
    const fetchResourceUtilization = async () => {
      setChartData(prev => ({ ...prev, loading: true, error: null, noData: false }));

      try {
        const response = await api.get('/resource-by-assets-type', {
          params: { asset_id: assetId }
        });

        const { used_quantity, available_quantity, asset_name } = response.data;

        const used = parseInt(used_quantity, 10);
        const available = parseInt(available_quantity, 10);

        if ((used + available) === 0) {
          setChartData({
            series: [0, 0],
            assetName: asset_name || '',
            loading: false,
            error: null,
            noData: true
          });
          return;
        }

        setChartData({
          series: [available, used],
          assetName: asset_name || '',
          loading: false,
          error: null,
          noData: false
        });

      } catch (error) {
        setChartData({
          series: [0, 0],
          assetName: '',
          loading: false,
          error: error.message || 'Failed to fetch data',
          noData: false
        });
      }
    };

    fetchResourceUtilization();
  }, [assetId]);

  const options = {
    labels: ["Available", "Used"],
    chart: {
      type: "donut",
      height: '100%',
      fontFamily: "Plus Jakarta Sans, sans-serif",
      foreColor: "#adb0bb",
    },
    plotOptions: {
      pie: {
        donut: {
          size: '85%',
          labels: {
            show: true,
            name: {
              show: true,
              offsetY: 7,
              fontSize: '14px',
              fontWeight: 600
            },
            value: {
              show: false,
            },
            total: {
              show: true,
              fontSize: '14px',
              fontWeight: "600",
              color: '#5A6A85',
              label: chartData.assetName || 'Total',
              formatter: function (w) {
                const series = w.globals.series;
                const total = series.reduce((a, b) => a + b, 0);

                if (total === 0) return 'No data';

                const max = Math.max(...series);
                const index = series.indexOf(max);
                const percent = (max / total) * 100;

                return `${w.config.labels[index]} ${percent.toFixed(0)}%`;
              }
            },
          },
        },
      },
    },
    dataLabels: { enabled: false },
    stroke: { show: false },
    legend: { show: false },
    colors: ["#11DEB9", "#FFB53B"],
    tooltip: {
      theme: "dark",
      fillSeriesColor: false,
    },
  };

  const handleAssetChange = (id) => {
    setAssetId(id);
  };

  return (
    
      <div className="card w-100 mb-0 h-100">
        <div className="card-body">
          <h5 className="card-title fw-semibold">Resources by Type</h5>
          <p className="card-subtitle mb-4">Monitor how different resources are being utilized across cases.</p>

          <div className="search-filter row mb-4">
            <div className="col-lg-6 my-2">
              <AssetsDropdown onChange={handleAssetChange} />
            </div>
          </div>

          {chartData.loading ? (
            <div className="w-full h-64 flex items-center justify-center">Loading...</div>
          ) : chartData.error ? (
            <div className="w-full h-64 flex items-center justify-center text-red-500">{chartData.error}</div>
          ) : chartData.noData ? (
            <div className="w-full h-64 flex items-center justify-center text-gray-500">No data available for this asset</div>
          ) : (
            <div className="resources-panel">
              <div id="resource-utilization" className="w-full">
                <Chart options={options} series={chartData.series} type="donut" height="100%" />
              </div>
              <div className="value-indicator-panel pb-2 ps-5">
                <div className="value-indicator my-2">
                  <div className="rounded-circle me-3" style={{ width: '12px', height: '12px', backgroundColor: '#11DEB9' }}></div>
                  <span className="fw-semibold">Available</span>
                </div>
                <div className="value-indicator my-2">
                  <div className="rounded-circle me-3" style={{ width: '12px', height: '12px', backgroundColor: '#FFB53B' }}></div>
                  <span className="fw-semibold">Used</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    
  );
};

export default ResourceUtilizationChart;
